import { render } from "./TheEditListItem.vue?vue&type=template&id=5b64662c&scoped=true&ts=true"
import script from "./TheEditListItem.vue?vue&type=script&lang=ts"
export * from "./TheEditListItem.vue?vue&type=script&lang=ts"

import "./TheEditListItem.vue?vue&type=style&index=0&id=5b64662c&scoped=true&lang=scss"

import exportComponent from "/data/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b64662c"]])

export default __exports__